import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { metaReducers, reducers } from './app.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LoginEffects } from '../../access/login/state/login.effects';
import { environment } from '../../../environments/environment';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, { metaReducers }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    EffectsModule.forFeature([LoginEffects]),
    StoreDevtoolsModule.instrument({ maxAge: 50 }),
  ],
  exports: [StoreModule],
})
export class AppStoreModule {
}
